import { useEffect } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { settingsApi } from '../../api/contentApi';
import { useCookieConsent } from '../../hooks/useCookieConsent';

/**
 * Injecte les scripts de suivi configurés depuis Paramètres → Suivi & analytics
 * (Google Analytics, Google Tag Manager, Pixel Meta). Ne s'exécute qu'une fois
 * par identifiant, uniquement côté site public, et seulement si le visiteur a
 * donné son consentement via le bandeau cookies (RGPD).
 */
export function AnalyticsScripts() {
  const { data: settings } = useFetch(() => settingsApi.public(), []);
  const consent = useCookieConsent();
  const analyticsAutorises = consent?.analytics === true;

  const gaId = analyticsAutorises ? settings?.['analytics.google_analytics_id'] : null;
  const gtmId = analyticsAutorises ? settings?.['analytics.google_tag_manager_id'] : null;
  const pixelId = analyticsAutorises ? settings?.['analytics.meta_pixel_id'] : null;

  useEffect(() => {
    if (!gaId || document.getElementById('ga-script')) return;

    const loader = document.createElement('script');
    loader.id = 'ga-script';
    loader.async = true;
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
    document.head.appendChild(loader);

    const inline = document.createElement('script');
    inline.id = 'ga-inline';
    inline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', ${JSON.stringify(gaId)});
    `;
    document.head.appendChild(inline);
  }, [gaId]);

  useEffect(() => {
    if (!gtmId || document.getElementById('gtm-script')) return;

    const inline = document.createElement('script');
    inline.id = 'gtm-script';
    inline.textContent = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', ${JSON.stringify(gtmId)});
    `;
    document.head.appendChild(inline);

    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmId)}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.prepend(noscript);
  }, [gtmId]);

  useEffect(() => {
    if (!pixelId || document.getElementById('meta-pixel-script')) return;

    const inline = document.createElement('script');
    inline.id = 'meta-pixel-script';
    inline.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', ${JSON.stringify(pixelId)});
      fbq('track', 'PageView');
    `;
    document.head.appendChild(inline);
  }, [pixelId]);

  return null;
}
